import * as React from 'react';
import { Loading } from './Loading';

export const LoadingInline: React.FCC = () => <Loading isInline />;
LoadingInline.displayName = 'LoadingInline';
